var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile is-vertical"},[_c('FormMusic',{attrs:{"formdata":_vm.item},on:{"settingForm":_vm.setBeatData}}),_c('div',{staticClass:"tile is-parent"},[_c('button',{class:{'button is-success h-margin-center':true, 'is-loading':_vm.isLoading},on:{"click":function($event){return _vm.updateBeat()}}},[_vm._v("Guardar")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }